<template>
  <v-container class="px-0 my-3">
    <v-row class="bg-white">
      <v-col class="v-col-12 v-col-lg-8 offset-lg-2 d-flex justify-center">
        <v-timeline direction="horizontal" truncate-line="both" class="checkout-timeline">
          <v-timeline-item fill-dot size="65px" :class="step.one">
            <template v-slot:opposite>
              <span class="font-weight-bold">Dados Pessoais</span>
            </template>
            <template v-slot:icon>
              <span class="font-weight-bold text-xlarge">1</span>
            </template>
          </v-timeline-item>
          <v-timeline-item fill-dot size="65px" :class="step.two">
            <span class="font-weight-bold">Endereço</span>
            <template v-slot:icon>
              <span class="font-weight-bold text-xlarge">2</span>
            </template>
          </v-timeline-item>
        </v-timeline>
      </v-col>
      <v-col cols="12">
        <hr class="fine-line">
      </v-col>
      <v-col class="v-col-12 v-col-lg-6 offset-lg-3">
        <v-form ref="step1" lazy-validation v-if="step.one == 'active'">
          <v-text-field variant="outlined" v-model="user.cpf" v-maska:[masks.cpf] validate-on="submit" :rules="[rules.required, rules.validCpfCnpj]" label="CPF/CNPJ" :placeholder="is_empresa == 0 ? 'Ex: 000.000.000-00' : 'Ex: 00.000.000/0000-00'" required></v-text-field>
          <v-text-field class="mt-2" variant="outlined" v-model="user.name" :rules="[rules.required, rules.minName]" :label="is_empresa == 0 ? 'Nome e Sobrenome' : 'Razão Social'" :placeholder="is_empresa == 0 ? 'Digite seu nome' : 'Digite seu Razão Social'"></v-text-field>
          <v-text-field class="mt-2" variant="outlined" v-model="user.email" :rules="[rules.required, rules.validEmail]" label="E-mail" placeholder="Ex: exemplo@gmail.com"></v-text-field>
          <v-text-field class="mt-2" variant="outlined" v-model="user.password" validate-on="submit" :rules="[rules.required]" label="Senha" placeholder="Digite sua senha" :type="showPassword ? 'text' : 'password'" :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" @click:appendInner="showPassword = !showPassword" autocomplete="new-password"></v-text-field>
          <v-text-field class="mt-2" variant="outlined" v-model="user.phone" v-maska:[masks.phone] :rules="[rules.required, rules.minPhone]" label="Celular" placeholder="Ex: (00) 00000-0000"></v-text-field>
          <v-select class="mt-2" v-model="user.gender" label="Gênero" :items="genders" item-title="descricao" item-value="id" v-if="is_empresa == 0"></v-select>
          <v-text-field class="mt-2" variant="outlined" v-model="user.birth_date" v-maska:[masks.date] :rules="[rules.required, rules.minDate, rules.validDate, rules.maiorData, rules.menorIdade]" :label="is_empresa == 0 ? 'Data de Nascimento' : 'Data abertura'" placeholder="Ex: 01/01/1980"></v-text-field>
        </v-form>
        <v-form ref="step2" lazy-validation v-if="step.two == 'active'">
          <v-text-field variant="outlined" v-model="user.address.address_nickname" :rules="[rules.required]" label="Descrição" placeholder="Ex: Minha Casa"></v-text-field>
          <v-text-field class="mt-2" variant="outlined" v-model="user.address.zip_code" v-maska:[masks.cep] :rules="[rules.required, rules.minMaxCep]" label="CEP" placeholder="Ex: 00000-000" :loading="loading" @keyup="findCep()"></v-text-field>
          <v-text-field class="mt-2" variant="outlined" v-model="user.address.street" label="Rua" :rules="[rules.required]" placeholder="Ex: Rua das Flores"></v-text-field>
          <v-text-field class="mt-2" variant="outlined" v-model="user.address.num" label="Número" :rules="[rules.required]" placeholder="Ex: 123"></v-text-field>
          <v-text-field class="mt-2" variant="outlined" v-model="user.address.complement" label="Complemento" placeholder="Ex: Residência"></v-text-field>
          <v-text-field class="mt-2" variant="outlined" v-model="user.address.district" label="Bairro" :rules="[rules.required]" placeholder="Qual o seu bairro?"></v-text-field>
          <v-text-field class="mt-2" variant="outlined" v-model="user.address.city" label="Cidade" :rules="[rules.required]" placeholder="Qual a sua cidade?"></v-text-field>
          <v-select class="mt-2" v-model="user.address.state" label="Estado" :rules="[rules.required]" :items="estados" item-title="descricao" item-value="sigla"></v-select>
          <v-checkbox density="compact" hide-details label="Desejo receber novidades e promoções do estabelecimento " class="text-color-0" v-model="autorizacao"></v-checkbox>
        </v-form>
      </v-col>
      <v-col cols="12">
        <hr class="fine-line">
      </v-col>
      <v-col v-if="step.one == 'active'" class="v-col-12 v-col-lg-6 offset-lg-3">
        <v-btn variant="flat" block size="x-large" class="bg-color-1 text-color-white" @click="nextStep()">Continuar</v-btn>
      </v-col>
      <v-col v-if="step.two == 'active'" class="v-col-12 v-col-lg-3 offset-lg-3">
        <v-btn variant="flat" block size="x-large" class="bg-color-gray text-color-0" @click="previousStep()">Voltar</v-btn>
      </v-col>
      <v-col v-if="step.two == 'active'" class="v-col-12 v-col-lg-3">
        <v-btn variant="flat" block size="x-large" class="bg-color-1 text-color-white" @click="addAddress()">Confirmar</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { validaCpfCnpj } from '@/store/services/utils.js';
export default {
  name: 'Register',
  data(){
    return {
      register: true,
      loading: false,
      showPassword: false,
      step: {
        one: 'active',
        two: ''
      },
      is_empresa: 0,
      user: {
        cpf: "",
        name: "",
        password: "",
        email: "",
        phone: "",
        gender: 0,
        birth_date: "",
        pushs: {
          offer: 0,
          note: 0,
          email: 0
        },
        address: {
          address_nickname: "",
          street: "",
          num: "",
          zip_code: "",
          district: "",
          city: "",
          state: "",
          complement: ""
        }
      },
      masks: {
        cpf: {
          mask: (value) => value.length > 14 ? '**.***.***/####-##' : "***.***.**#-##",
        },
        phone: {
          mask: "(##) #####-####",
        },
        date: {
          mask: "##/##/####",
        },
        cep: {
          mask: "#####-###",
        },
      },
      rules: {
        required: v => !!v || 'Este campo é obrigatório.',
        validCpfCnpj: v => (v && this.isValidCpfCnpj(v)) || 'Número de documento inválido.',
        minName: v => (v && v.length >= 3) || 'Este campo deve conter no mínimo 3 caracteres.',
        minPhone: v => (v && v.length >= 15) || 'Este campo deve conter no mínimo 15 caracteres.',
        minDate: v => (v && v.length >= 10) || 'Este campo deve conter no mínimo 10 caracteres.',
        minMaxCep: v => (v && v.length == 9) || 'Este campo deve conter 9 caracteres.',
        validDate: v => (v && this.isValidDate(v)) || 'A data informada não é válida',
        maiorData: v => (v && this.isMaiorData(v)) || 'A data informada não pode ser maior que a atual.',
        validEmail: v => (v && this.isValidEmail(v)) || 'O e-mail informado não é válido.',
        menorIdade: v => (v && this.isMenorIdade(v)) || 'Para a utilização de nossa plataforma sua idade deve ser maior que 18 anos.'
      },
      autorizacao: 0,
    }
  },
  computed: {
    ...mapState('main', {
      estados: 'estados',
      genders: 'genders'
    }),
    ...mapGetters('main', {
      getConfig: 'getConfig'
    })
  },
  watch: {
    'user.cpf'(value){
      this.is_empresa = value.length > 14 ? 1 : 0;
    },
    autorizacao(autorizacao){
      this.user.pushs.email = autorizacao ? 1 : 0;
      this.user.pushs.note = autorizacao ? 1 : 0;
      this.user.pushs.offer = autorizacao ? 1 : 0;
    }
  },
  methods: {
    ...mapActions('main', {
      setConfig: 'setConfig'
    }),
    ...mapActions('user', {
      registerUser: 'registerUser',
      addressZipCode: 'addressZipCode',
      verifyDocument: 'verifyDocument'
    }),
    findCep(){
      if(this.user.address.zip_code.length == 9){
        this.loading = true;
        this.addressZipCode(this.user.address.zip_code.replace("-", "")).then(function(response){
          if(response){
            this.user.address.street = response.street;
            this.user.address.district = response.district;
            this.user.address.city = response.city;
            this.user.address.state = response.state;
            this.user.address.complement = response.complement;
          } else {
            this.user.address.street = "";
            this.user.address.district = "";
            this.user.address.city = "";
            this.user.address.state = "";
            this.user.address.complement = "";
          }
          this.loading = false;
        }.bind(this));
      }
    },
    isValidCpfCnpj(value){
      return validaCpfCnpj(value);
    },
    isValidEmail(value){
      return String(value).toLowerCase().match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/);
    },
    isValidDate(value){
        var splitData = value.split('/');
        var dateNow = new Date();
        if(splitData[0].length == 2 && (parseInt(splitData[0]) <= 0 || parseInt(splitData[0]) > 31)){
            return false;
        } else if(splitData[1] != undefined && splitData[1].length == 2 && (parseInt(splitData[1]) <= 0 || parseInt(splitData[1]) > 12)){
            return false;
        } else if(splitData[2] != undefined && splitData[2].length == 4 && (parseInt(splitData[2]) < dateNow.getFullYear() - 100)){
            return false;
        } else {
            return true;
        }
    },
    isMaiorData(value) {
        var splitData = value.split('/');
        var dateNow = new Date();
        splitData = new Date(parseInt(splitData[2]), parseInt(splitData[1]) -1, parseInt(splitData[0]), 0, 0, 0);
        return splitData <= dateNow;
    },
    isMenorIdade(value){
        var splitData = value.split('/');
        var today = new Date();
        var birthDate = new Date(splitData[2], splitData[1]-1, splitData[0], 0, 0, 0);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age < 18 && this.is_empresa == 0 ? false : true;
    },
    async nextStep(){
      const { valid } = await this.$refs.step1.validate();
      if (valid){
        this.verifyDocument(this.user.cpf).then(function(response){
          if(response != ""){
            this.emitter.emit('dialogMessage', { title: "Atenção!", message: response });
          } else {
            this.step.one = "completed";
            this.step.two = "active";
          }
        }.bind(this));
      }
    },
    previousStep(){
      this.step.one = "active";
      this.step.two = "";
    },
    async addAddress(){
      const { valid } = await this.$refs.step2.validate();
      if (valid){
        this.emitter.emit('dialogAddress', { address: this.user.address, register: this.finishRegister });
      }
    },
    finishRegister: function(address){
      let user = this.user;
      user.cpf = this.removemask(user.cpf);
      user.phone = this.removemask(user.phone);
      user.address = address;
      if(user.birth_date.includes("/")){
        let birth_date = user.birth_date.split('/');
        user.birth_date = birth_date[2] + "-" + birth_date[1] + "-" + birth_date[0];
      }
      this.registerUser(user).then((response) => {
        if(response == true){
          this.$router.push('/');
        } else {
          this.emitter.emit('dialogMessage', { title: "Atenção!", message: response });
        }
      });
    },
    removemask(value){
      return value.replaceAll(".", "").replaceAll(" ", "").replaceAll("(", "").replaceAll(")", "").replaceAll("-", "").replaceAll("/", "");
    }
  },
  mounted(){
    this.setConfig().then(function(retorno){
      if(retorno){
        if(this.getConfig.isu > 0){
          this.$router.push('/');
        }
      } else {
        this.emitter.emit('dialogStores');
      }
    }.bind(this))
    .catch(function () {
      this.$router.push("/baixeoapp");
    }.bind(this));
  }
};
</script>